<template>
  <div class="container">
    <h1 class="questionnaire_title">
      Анкета для страхования грузов
    </h1>
    <a-form 
      layout="vertical" 
    >
      <div class="questionnaire_card">
        <p class="questionnaire_card_title">
          1. Сведения о страхователе
        </p>
        <a-form-item 
          label="Укажите БИН" 
          name="policyholder_bin"
          :class="errors.includes('policyholder_bin') ? 'error_text' : ''"
        >
          <a-input
            v-model:value="formState.policyholder_bin.value"
            v-mask="'#### #### ####'"
            :status="errors.includes('policyholder_bin') ? 'error' : ''" 
            class="questionnaire_card_input" 
            placeholder="0000 0000 0000" 
            @change="(e) => onChangeIINorBIN(e, 'policyholder_bin', 'policyholder_name')"
          />
        </a-form-item>
        <a-form-item 
          :class="errors.includes('policyholder_name') ? 'error_text' : ''"
          label="Наименование юридического лица" 
          name="policyholder_name" 
        >
          <a-spin :spinning="formState.policyholder_name.isLoading">
            <a-input 
              v-model:value="formState.policyholder_name.value" 
              :status="errors.includes('policyholder_name') ? 'error' : ''" 
              class="questionnaire_card_input" 
              placeholder="Наименование"
              disabled
            />
          </a-spin>
        </a-form-item>
        <a-form-item 
          name="isPolicyholderIsBeneficiary" 
        >
          <a-checkbox
            v-model:checked="isPolicyholderIsInsured"
            @click="isPolicyholderIsInsuredChecked"
          >
            Является ли страхователь застрахованым?
          </a-checkbox>
        </a-form-item>
        <a-form-item 
          name="isPolicyholderIsBeneficiary" 
        >
          <a-checkbox
            v-model:checked="isPolicyholderIsBeneficiary"
            @click="isPolicyholderIsBeneficiaryChecked"
          >
            Является ли страхователь выгодоприобретателем?
          </a-checkbox>
        </a-form-item>
      </div>
      <div class="questionnaire_card">
        <p class="questionnaire_card_title">
          2. Сведения о застрахованном
        </p>
        <a-form-item 
          label="Укажите БИН" 
          name="insured_bin" 
          :class="errors.includes('insured_bin') ? 'error_text' : ''"
        >
          <a-input 
            v-model:value="formState.insured_bin.value"  
            v-mask="'#### #### ####'" 
            :status="errors.includes('insured_bin') ? 'error' : ''" 
            class="questionnaire_card_input" 
            placeholder="0000 0000 0000" 
            max-length="14"  
            @change="(e) => onChangeIINorBIN(e, 'insured_bin', 'insured_name')"
          />
        </a-form-item>
        <a-form-item 
          label="Наименование юридического лица" 
          name="insured_name" 
          :class="errors.includes('insured_name') ? 'error_text' : ''"
          disabled
        >
          <a-spin :spinning="formState.insured_name.isLoading">
            <a-input 
              v-model:value="formState.insured_name.value" 
              :status="errors.includes('insured_name') ? 'error' : ''"  
              class="questionnaire_card_input" 
              placeholder="Наименование"
              disabled
            />
          </a-spin>
        </a-form-item>
      </div>
      <div class="questionnaire_card">
        <p class="questionnaire_card_title">
          3. Сведения о выгодоприобретателе
        </p>
        <a-form-item 
          label="Укажите БИН"
          name="beneficiary_bin"
          :class="errors.includes('beneficiary_bin') ? 'error_text' : ''" 
        >
          <a-input 
            v-model:value="formState.beneficiary_bin.value"  
            v-mask="'#### #### ####'"  
            :status="errors.includes('beneficiary_bin') ? 'error' : ''" 
            class="questionnaire_card_input" 
            placeholder="0000 0000 0000" 
            max-length="14"  
            @change="(e) => onChangeIINorBIN(e, 'beneficiary_bin', 'beneficiary_name')"
          />
        </a-form-item>
        <a-form-item 
          label="Наименование юридического лица" 
          name="beneficiary_name"
          :class="errors.includes('beneficiary_name') ? 'error_text' : ''" 
          disabled
        >
          <a-spin :spinning="formState.beneficiary_name.isLoading">
            <a-input 
              v-model:value="formState.beneficiary_name.value" 
              :status="errors.includes('beneficiary_name') ? 'error' : ''" 
              class="questionnaire_card_input" 
              placeholder="Наименование"
              disabled
            />
          </a-spin>
        </a-form-item>
      </div>
      <div class="questionnaire_card">
        <p class="questionnaire_card_title">
          4. Сведения о грузе
        </p>
        <a-form-item 
          label="Укажите наименование груза" 
          name="cargo_name" 
          :class="errors.includes('cargo_name') ? 'error_text' : ''" 
        >
          <a-input 
            v-model:value="formState.cargo_name.value" 
            class="questionnaire_card_input" 
            placeholder="Наименование груза" 
            @change="(e) => onChangeFields(e, 'cargo_name', 'text')"
          />
        </a-form-item>
        <a-form-item 
          label="Укажите тип объекта" 
          name="cargo_type_id" 
          :class="errors.includes('cargo_type_id') ? 'error_text' : ''" 
        >   
          <a-spin :spinning="formState.cargo_type_id.isLoading">
            <a-select 
              v-model:value="formState.cargo_type_id.value"
              :status="errors.includes('cargo_type_id') ? 'error' : ''" 
              placeholder="Тип обьекта"
              class="questionnaire_card_select" 
              :options="dictis.cargo_types" 
              @change="(e) => onChangeFields(e, 'cargo_type_id', 'select')"
            />
          </a-spin>
        </a-form-item>
        <a-row gutter="16">
          <a-col span="8">
            <a-form-item 
              label="Количество мест" 
              name="seats" 
              :class="errors.includes('seats') ? 'error_text' : ''" 
            >
              <a-input-number
                v-model:value="formState.seats.value"
                type="number" 
                :status="errors.includes('seats') ? 'error' : ''" 
                class="questionnaire_card_input" 
                placeholder="0"
                @change="(e) => onChangeFields(e, 'seats', 'number')"
              />
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item 
              label="Вес" 
              name="weight" 
              :class="errors.includes('weight') ? 'error_text' : ''" 
            >
              <a-input-number
                v-model:value="formState.weight.value"
                type="number" 
                :status="errors.includes('weight') ? 'error' : ''" 
                class="questionnaire_card_input" 
                placeholder="0"
                @change="(e) => onChangeFields(e, 'weight', 'number')"
               
              >
              <template #addonAfter>
                <a-select v-model:value="formState.weight_unit.value" style="width: 70px">
                  <a-select-option value="т">т</a-select-option>
                  <a-select-option value="кг">кг</a-select-option>
                </a-select>
              </template>
            </a-input-number>
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item 
              label="Объем м3" 
              name="volume" 
            >
              <a-input-number
                v-model:value="formState.volume.value"
                type="number" 
                class="questionnaire_card_input" 
                placeholder="0 м3"
                @change="(e) => onChangeFields(e, 'volume', 'number')"
              />
            </a-form-item>
            <a-form-item 
              name="volume_unit" 
              hidden
              initialValue="м3"
            >
              <a-input value="м3"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item 
          label="Укажите вид упаковки груза" 
          name="package_type_id" 
          :class="errors.includes('package_type_id') ? 'error_text' : ''" 
        >
          <a-spin :spinning="formState.package_type_id.isLoading">
            <a-select 
              v-model:value="formState.package_type_id.value" 
              :status="errors.includes('package_type_id') ? 'error' : ''" 
              placeholder="Тип упаковки" 
              class="questionnaire_card_select" 
              :options="dictis.package_types" 
            />
          </a-spin>
        </a-form-item>
        <a-form-item 
          label="Код ТНВЭД" 
          name="tnved_code_id" 
          :class="errors.includes('tnved_code_id') ? 'error_text' : ''" 
        >
          <a-spin :spinning="formState.tnved_code_id.isLoading">
            <a-select 
              v-model:value="formState.tnved_code_id.value" 
              :status="errors.includes('tnved_code_id') ? 'error' : ''" 
              placeholder="Код ТНВЭД" 
              class="questionnaire_card_select" 
              :options="dictis.tnved_codes"
            />
          </a-spin>
        </a-form-item>
        <a-form-item 
          name="has_special_properties" 
          :class="errors.includes('has_special_properties') ? 'error_text' : ''" 
        >
          <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                Особые свойства (класс опасности)
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.has_special_properties.value"
                :status="errors.includes('has_special_properties') ? 'error' : ''" 
                name="radioGroup" 
                class="questionnaire_card_radio"
                @change="(e) => onChangeFields(e, 'has_special_properties', 'radio')"
              >
                <a-radio :value="1">
                  Да
                </a-radio>
                <a-radio :value="0">
                  Нет
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          label="Примечание" 
          name="special_properties_comment" 
          :hidden="!formState.has_special_properties.value"
          :class="errors.includes('special_properties_comment') ? 'error_text' : ''" 
        >
          <a-input 
            v-model:value="formState.special_properties_comment.value" 
            :status="errors.includes('special_properties_comment') ? 'error' : ''" 
            class="questionnaire_card_input" 
            placeholder="Опишите кратко почему груз опасный"
          />
        </a-form-item>
        <a-form-item 
          label="Укажите стоимость груза" 
          name="cargo_price"
          :class="errors.includes('cargo_price') ? 'error_text' : ''" 
        >
          <a-input
            v-model:value="formState.cargo_price.value" 
            :status="errors.includes('cargo_price') ? 'error' : ''" 
            type="number" 
            class="questionnaire_card_input questionnaire_card_input_number" 
            placeholder="Стоимость груза тг." 
            @change="(e) => onChangeFields(e, 'cargo_price', 'number')"
          />
        </a-form-item>
        <a-form-item 
          name="has_transport_expenses" 
          :class="errors.includes('has_transport_expenses') ? 'error_text' : ''" 
        >
          <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                С учетом расходов на организацию перевозки
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.has_transport_expenses.value"
                :status="errors.includes('has_transport_expenses') ? 'error' : ''" 
                name="radioGroup"
                class="questionnaire_card_radio"  
                @change="(e) => onChangeFields(e, 'has_transport_expenses', 'radio')"
              >
                <a-radio :value="1">
                  Да
                </a-radio>
                <a-radio :value="0">
                  Нет
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          label="Расходы на организацию перевозки" 
          name="transport_expenses" 
          :hidden="!formState.has_transport_expenses.value"
          :class="errors.includes('transport_expenses') ? 'error_text' : ''" 
        >
          <a-input-number
            v-model:value="formState.transport_expenses.value"
            :status="errors.includes('transport_expenses') ? 'error' : ''" 
            type="number" 
            class="questionnaire_card_input questionnaire_card_input_number" 
            placeholder="Сумма до 20% от стоимости груза"  
            @change="(e) => onChangeFields(e, 'transport_expenses', 'number')"
          />
        </a-form-item>
        <p :clasee="errors.includes('insurance_start_date') || errors.includes('insurance_end_date') ? 'error' : ''">
          Укажите срок страхования груза
        </p>
        <a-row gutter="14">
          <a-col span="12">
            <a-form-item 
              name="insurance_start_date"
              :class="errors.includes('insurance_start_date') ? 'error_text' : ''" 
            >
              <a-config-provider :locale="ruRu">
                <a-date-picker 
                  v-model:value="formState.insurance_start_date.value"
                  :status="errors.includes('insurance_start_date') ? 'error' : ''" 
                  placeholder="Дата начала страхования" 
                  :disabled-date="disableStartDate"
                  class="questionnaire_card_datepicker" 
                  @change="(e) => onChangeFields(e, 'insurance_start_date', 'date')"
                />
            </a-config-provider>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item  
              name="insurance_end_date"
              :class="errors.includes('insurance_end_date') ? 'error_text' : ''" 
            >
            <a-config-provider :locale="ruRu">
              <a-date-picker 
                v-model:value="formState.insurance_end_date.value"
                :status="errors.includes('insurance_end_date') ? 'error' : ''" 
                placeholder="Дата завершения страхования" 
                :disabled-date="disableEndDate"
                class="questionnaire_card_datepicker" 
                @change="(e) => onChangeFields(e, 'insurance_end_date', 'date')"
              />
            </a-config-provider>
              
            </a-form-item>
          </a-col>
        </a-row>
        <a-row
          v-if="formState.insurance_amount.value"
          class="questionnaire_card_insuranse_sum"
          gutter="6"
        >
          <a-col>
            <h3 class="questionnaire_card_insuranse_sum_title">
              Страховая сумма:
            </h3>
          </a-col>
          <a-col>
            <h3 class="questionnaire_card_insuranse_sum_data">
              {{ `${formState.insurance_amount.value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }} тенге
            </h3>
          </a-col>
        </a-row>
      </div>
      <div class="questionnaire_card">
        <p class="questionnaire_card_title">
          5. Сведения о перевозке груза
        </p>
        <a-form-item  
          label="Укажите вид транспортного средства" 
          name="transport_category_id"
          :class="errors.includes('transport_category_id') ? 'error_text' : ''" 
        >
          <a-spin :spinning="formState.transport_category_id.isLoading">
            <a-select 
              v-model:value="formState.transport_category_id.value"
              :status="errors.includes('transport_category_id') ? 'error' : ''" 
              placeholder="Вид транспортного средства" 
              class="questionnaire_card_select" 
              :options="dictis.transport_categories"
              @change="(e) => onChangeFields(e, 'transport_category_id', 'select')"
            />
          </a-spin>
        </a-form-item>
        <a-form-item
          v-for="(domain, index) in formState.transport_types.values" 
          :key="domain.key" 
          label="Укажите тип транспортного средства" 
          name="transport_types"
          :class="['dynamicFormItem', {'error_text': errors.includes('transport_types')}]"
        >
          <a-spin :spinning="formState.transport_types.isLoading">
            <a-tree-select 
              v-model:value="formState.transport_types.values[index].value"
              :status="errors.includes('transport_types') ? 'error' : ''"
              leaf-only="true"  
              :tree-checkable="false"
              :tree-selectable="true"
              label-in-value="false" 
              placeholder="Тип транспортного средства" 
              class="questionnaire_card_select" 
              :tree-data="dictis.transport_types" 
              @change="(e) => onChangeFields(e, 'transport_types', 'treeSelect', index)"
            />
          </a-spin>
          <MinusCircleOutlined
            v-if="formState.transport_types.values.length > 1"
            class="dynamic-delete-button"
            @click="removeDomain(domain, index)"
          />
        </a-form-item>
        <a-button
          v-if="Number(formState.transport_category_id.value) === 5 && formState.transport_types.values.length < 4"
          type="dashed"
          class="mb-3"
          style="width: 100%"
          @click="addDomain"
        >
          <PlusOutlined />
          Добавить тип транспортного средства
        </a-button>
        <a-form-item 
          name="has_forwarder" 
          :class="errors.includes('has_forwarder') ? 'error_text' : ''" 
        >
          <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                Имеется ли экспедиатор?
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.has_forwarder.value"
                :status="errors.includes('has_forwarder') ? 'error' : ''" 
                name="radioGroup"
                class="questionnaire_card_radio"  
                @change="(e) => onChangeFields(e, 'has_forwarder', 'radio')"
              >
                <a-radio :value="true">
                  Да
                </a-radio>
                <a-radio :value="false">
                  Нет
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          name="forwarder_type"
          :class="errors.includes('forwarder_type') ? 'error_text' : ''" 
          v-if="formState.has_forwarder.value"
        >
          <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                Экспедитор
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.forwarder_type.value"
                :status="errors.includes('forwarder_type') ? 'error' : ''" 
                name="radioGroup" 
                class="questionnaire_card_radio"
              >
                <a-radio :value="1">
                  ИП/КХ
                </a-radio>
                <a-radio :value="2">
                  Юридическое лицо
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          label="Укажите БИН экспедитора" 
          name="forwarder_bin"
          v-if="formState.has_forwarder.value"
          :class="errors.includes('forwarder_bin') ? 'error_text' : ''" 
        >
          <a-input 
            v-model:value="formState.forwarder_bin.value"
            v-mask="'#### #### ####'" 
            :status="errors.includes('forwarder_bin') ? 'error' : ''" 
            class="questionnaire_card_input questionnaire_card_input_number"
            placeholder="0000 0000 0000" 
            max-length="14" 
            @change="(e) => onChangeIINorBIN(e, 'forwarder_bin', 'forwarder_name')"
          />
        </a-form-item>
        <a-form-item 
          label="Наименование экспедиатора" 
          name="forwarder_name"
          v-if="formState.has_forwarder.value"
          :class="errors.includes('forwarder_name') ? 'error_text' : ''" 
          disabled
        >
          <a-spin :spinning="formState.forwarder_name.isLoading">
            <a-input 
              v-model:value="formState.forwarder_name.value"
              :status="errors.includes('forwarder_name') ? 'error' : ''" 
              class="questionnaire_card_input" 
              placeholder="Наименование экспедиатора"
              disabled
            />
          </a-spin>
        </a-form-item>
        <a-form-item 
          name="has_autocarrier" 
          :class="errors.includes('has_autocarrier') ? 'error_text' : ''" 
        >
        <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                Имеется ли автоперевозчик?
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.has_autocarrier.value"
                :status="errors.includes('has_autocarrier') ? 'error' : ''" 
                name="radioGroup"
                class="questionnaire_card_radio"  
                @change="(e) => onChangeFields(e, 'has_autocarrier', 'radio')"
              >
                <a-radio :value="true">
                  Да
                </a-radio>
                <a-radio :value="false">
                  Нет
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          name="autocarrier_type"
          :class="errors.includes('autocarrier_type') ? 'error_text' : ''" 
          v-if="formState.has_autocarrier.value"
        >
          <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                Автоперевозчик
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.autocarrier_type.value"
                :status="errors.includes('autocarrier_type') ? 'error' : ''" 
                name="radioGroup" 
                class="questionnaire_card_radio"
              >
                <a-radio :value="1">
                  ИП/КХ
                </a-radio>
                <a-radio :value="2">
                  Юридическое лицо
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          label="Укажите БИН автоперевозчика" 
          name="autocarrier_bin"
          :class="errors.includes('autocarrier_bin') ? 'error_text' : ''" 
           v-if="formState.has_autocarrier.value"
        >
          <a-input 
            v-model:value="formState.autocarrier_bin.value"
            v-mask="'#### #### ####'" 
            :status="errors.includes('autocarrier_bin') ? 'error' : ''" 
            class="questionnaire_card_input questionnaire_card_input_number" 
            placeholder="0000 0000 0000"
            @change="(e) => onChangeIINorBIN(e, 'autocarrier_bin', 'autocarrier_name')" 
          />
        </a-form-item>
        <a-form-item 
          label="Наименование автоперевозчика" 
          name="autocarrier_name"
          :class="errors.includes('autocarrier_name') ? 'error_text' : ''" 
          v-if="formState.has_autocarrier.value"
          disabled
        >
          <a-spin :spinning="formState.autocarrier_name.isLoading">
            <a-input 
              v-model:value="formState.autocarrier_name.value"
              :status="errors.includes('autocarrier_name') ? 'error' : ''" 
              class="questionnaire_card_input" 
              placeholder="Наименование автоперевозчика"
              disabled
            />
          </a-spin>
        </a-form-item>
        <a-form-item 
          label="Номер перевозочной накладной / Номер инвойса" 
          name="invoice_number"
          :class="errors.includes('invoice_number') ? 'error_text' : ''" 
        >
          <a-input  
            v-model:value="formState.invoice_number.value"
            :status="errors.includes('invoice_number') ? 'error' : ''" 
            class="questionnaire_card_input questionnaire_card_input_number" 
            placeholder=" № 0000 0000 0000"
          />
        </a-form-item>
        <a-divider />
        <a-form-item 
          label="Укажите пункт отправления" 
          name="departure_point"
          :class="errors.includes('departure_point') ? 'error_text' : ''" 
        >
          <a-input 
            v-model:value="formState.departure_point.value"
            :status="errors.includes('departure_point') ? 'error' : ''" 
            class="questionnaire_card_input" 
            placeholder="Пункт отправления (Страна, Город, Улица, район, дом)"
          >
            <template #prefix>
              <img src="/location_icon.svg">
            </template>
          </a-input>
        </a-form-item>
        <a-form-item 
          label="Укажите пункт назначения" 
          name="destination_point"
          :class="errors.includes('destination_point') ? 'error_text' : ''" 
        >
          <a-input 
            v-model:value="formState.destination_point.value"
            :status="errors.includes('destination_point') ? 'error' : ''" 
            class="questionnaire_card_input" 
            placeholder="Пункт назначения (Страна, Город, Улица, район, дом)"
          >
            <template #prefix>
              <img src="/flag_icon.svg">
            </template>
          </a-input>
        </a-form-item>
        <a-divider />
        <a-form-item 
          name="has_transshipment_point"
          :class="errors.includes('has_transshipment_point') ? 'error_text' : ''" 
        >
          <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                Пункт перевалки
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.has_transshipment_point.value"
                :status="errors.includes('has_transshipment_point') ? 'error' : ''" 
                name="radioGroup" 
                class="questionnaire_card_radio"
                @change="(e) => onChangeFields(e, 'has_transshipment_point', 'radio')"
              >
                <a-radio :value="1">
                  Да
                </a-radio>
                <a-radio :value="0">
                  Нет
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          :class="errors.includes('transshipment_point_comment') ? 'error_text' : ''" 
          label="Укажите пункт перевалки" 
          name="transshipment_point_comment" 
          :hidden="!formState.has_transshipment_point.value"
        >
          <a-input
            v-model:value="formState.transshipment_point_comment.value"
            class="questionnaire_card_input"
            placeholder="Пункт перевалки"
          />
        </a-form-item>
        <a-form-item  
          name="has_overload_point"
          :class="errors.includes('has_overload_point') ? 'error_text' : ''" 
        >
          <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                Пункт перегрузки
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.has_overload_point.value"
                :status="errors.includes('has_overload_point') ? 'error' : ''" 
                name="radioGroup" 
                class="questionnaire_card_radio"  
                @change="(e) => onChangeFields(e, 'has_overload_point', 'radio')"
              >
                <a-radio :value="1">
                  Да
                </a-radio>
                <a-radio :value="0">
                  Нет
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          label="Укажите пункт перегрузки" 
          name="overload_point_comment" 
          :hidden="!formState.has_overload_point.value"
          :class="errors.includes('overload_point_comment') ? 'error_text' : ''" 
        >
          <a-input 
            v-model:value="formState.overload_point_comment.value"
            :status="errors.includes('overload_point_comment') ? 'error' : ''" 
            class="questionnaire_card_input" 
            placeholder="Пункт перегрузки"
          />
        </a-form-item>
        <a-form-item 
          name="has_temporary_storage_point"
          :class="errors.includes('has_temporary_storage_point') ? 'error_text' : ''" 
        >
          <a-row
            gutter="16"
            justify="space-between"
          >
            <a-col>
              <p class="col_p">
                Пункт временного хранения
              </p>
            </a-col>
            <a-col>
              <a-radio-group 
                v-model:value="formState.has_temporary_storage_point.value"
                :status="errors.includes('has_temporary_storage_point') ? 'error' : ''" 
                name="radioGroup" 
                class="questionnaire_card_radio" 
                @change="(e) => onChangeFields(e, 'has_temporary_storage_point', 'radio')"
              >
                <a-radio :value="1">
                  Да
                </a-radio>
                <a-radio :value="0">
                  Нет
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item 
          label="Укажите пункт временного хранения (покрытие не более 30 {{record.expiration_message}} в пунктах временного хранения)" 
          name="temporary_storage_comment" 
          :hidden="!formState.has_temporary_storage_point.value"
          :class="errors.includes('temporary_storage_comment') ? 'error_text' : ''"
        >
          <a-input 
            v-model:value="formState.temporary_storage_comment.value"
            :status="errors.includes('temporary_storage_comment') ? 'error' : ''" 
            class="questionnaire_card_input" 
            placeholder="Пункт временного хранения (покрытие не более 30 {{record.expiration_message}} в пунктах временного хранения)"
          />
        </a-form-item>
        <a-divider />
        <a-form-item 
          label="Полный маршрут перевозки" 
          name="full_transportation_route"
          :class="errors.includes('full_transportation_route') ? 'error_text' : ''"
        >
          <a-textarea 
            v-model:value="formState.full_transportation_route.value"
            :status="errors.includes('full_transportation_route') ? 'error' : ''" 
            class="questionnaire_card_input"
            placeholder="Полный маршрут перевозкия" 
            :rows="4"
          >
            <template #prefix>
              <img src="/flag_icon.svg">
            </template>
          </a-textarea>
        </a-form-item>
      </div>
      <div class="questionnaire_card">
        <p class="questionnaire_card_title">
          6. Необходимое страховое покрытие
        </p>
        <a-form-item 
          name="insurance_coverage_id"
          :class="errors.includes('insurance_coverage_id') ? 'error_text' : ''"
        >
          <a-radio-group 
            v-model:value="formState.insurance_coverage_id.value"
            :status="errors.includes('insurance_coverage_id') ? 'error' : ''" 
            class="questionnaire_card_radio_checkbox" 
            name="radioGroup" 
            @change="(e) => onChangeFields(e, 'insurance_coverage_id', 'radio')"
          >
            <a-radio :value="1">
              (А) all transport risks (полное покрытие)
            </a-radio>
            <a-radio :value="2">
              (В) limited coverage of transport risks (лимитированное покрытие)
            </a-radio>
            <a-radio :value="3">
              (С) minimum coverage of transport risks (минимальное покрытие)
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <div class="insurance_coverage_data">
          <div class="insurance_coverage_data_item" v-if="formState.insurance_coverage_id.value === 1">
            <p class="insurance_coverage_data_item_title">
              По Договору, заключенному на условиях «А», возмещаются убытки от утраты (гибели), недостачи, повреждения (порчи) всего или части застрахованного груза, происшедшие в результате следующих событий:
            </p>
            <p class="insurance_coverage_data_item_text">1) стихийных бедствий;</p>
            <p class="insurance_coverage_data_item_text"> 2) пожара, взрыва;</p>
            <p class="insurance_coverage_data_item_text">3) аварии (крушения), столкновения;</p>
            <p class="insurance_coverage_data_item_text">4) провала мостов, тоннелей;</p>
            <p class="insurance_coverage_data_item_text">5) нарушения технологии производства погрузочно-разгрузочных работ и временного хранения в пути следования;</p>
            <p class="insurance_coverage_data_item_text"> 6) полного неприбытия груза в пункт назначения, указанный в Договоре;</p>
            <p class="insurance_coverage_data_item_text">7) кражи, грабежа, разбоя, вандализма;</p>
            <p class="insurance_coverage_data_item_text">8) просадки судна на мель, выброса на берег, опрокидывания судна;</p>
            <p class="insurance_coverage_data_item_text">9) разгрузки груза в порту в результате аварии;</p>
            <p class="insurance_coverage_data_item_text">10) аварийного выбрасывания груза за борт или смытия груза за борт.</p>
          </div>
          <div class="insurance_coverage_data_item" v-if="formState.insurance_coverage_id.value === 2">
            <p class="insurance_coverage_data_item_title">
              По Договору, заключенному на условиях «В» возмещаются убытки от утраты (гибели) повреждения (порчи) всего или части застрахованного груза, происшедшие в результате следующих событий:
            </p>
            <p class="insurance_coverage_data_item_text">1) стихийных бедствий;</p>
            <p class="insurance_coverage_data_item_text">2) пожара, взрыва;</p>
            <p class="insurance_coverage_data_item_text">3) аварии (крушения), столкновения;</p>
            <p class="insurance_coverage_data_item_text">4) провала мостов, тоннелей;</p>
            <p class="insurance_coverage_data_item_text">5) нарушения технологии производства погрузочно-разгрузочных работ и временного хранения в пути следования;</p>
            <p class="insurance_coverage_data_item_text">6) полного неприбытия груза в пункт назначения, указанный в Договоре;</p>
            <p class="insurance_coverage_data_item_text">7) просадки судна на мель, выброса на берег, опрокидывания судна;</p>
            <p class="insurance_coverage_data_item_text">8) разгрузки груза в порту в результате аварии;</p>
            <p class="insurance_coverage_data_item_text">9)  аварийного выбрасывания груза за борт или смытия груза за борт.</p>
          </div>
          <div class="insurance_coverage_data_item"  v-if="formState.insurance_coverage_id.value === 3">
            <p class="insurance_coverage_data_item_title">
              По Договору, заключенному на условии «С», возмещаются: убытки от утраты (гибели) всего или части застрахованного груза, происшедшие в результате наступления следующих событий:
            </p>
            <p class="insurance_coverage_data_item_text">1) пожара, взрыва;</p>
            <p class="insurance_coverage_data_item_text">2) посадки на мель, выброса на берег, затопления или опрокидывания морского, речного судна, лихтера или баржи;</p>
            <p class="insurance_coverage_data_item_text">3) крушения транспортного средства;</p>
            <p class="insurance_coverage_data_item_text">4) опрокидывания или схода под откос (с рельсов) наземного транспортного средства;</p>
            <p class="insurance_coverage_data_item_text">5) столкновения транспортного средства с любым внешним предметом;</p>
            <p class="insurance_coverage_data_item_text">6) выгрузки груза в порту бедствия или в месте катастрофы;</p>
            <p class="insurance_coverage_data_item_text">Убытки от утраты (гибели) повреждения (порчи) всего или части застрахованного груза, происшедшие в результате аварии, крушения, столкновения.</p>
          </div>
        </div>
      </div>
      <a-row
        justify="end"
        gutter="16"
      >
        <a-button
          class="questionnaire_button_primary"
          @click="resetForm"
        >
          Очистить форму
        </a-button>
        <a-button
          class="questionnaire_button"
          type="primary"
          @click="submitForm"
        >
          Отправить
        </a-button>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { Form, Input, Checkbox, Select, Row, Col, Radio, InputNumber, DatePicker, Divider, Textarea, Button, Spin, TreeSelect, ConfigProvider} from 'ant-design-vue'
import ruRu from 'ant-design-vue/es/locale/ru_RU'
import {MinusCircleOutlined} from '@ant-design/icons-vue'
import axios from 'axios';
import { useToast } from 'vue-toastification'
import dayjs from 'dayjs';
import moment from 'moment';
import VueTheMask from 'vue-the-mask'
import 'moment/locale/ru';
import 'dayjs/locale/ru';
dayjs.locale('ru');
moment.locale('ru');
const toaster = useToast();

export default {
    components: { 
        AForm: Form, 
        AFormItem: Form.Item, 
        AInput: Input, 
        ACheckbox: Checkbox, 
        ASelect: Select, 
        ARow: Row, 
        ACol: Col, 
        ARadioGroup: Radio.Group, 
        ARadio: Radio, 
        AInputNumber: InputNumber, 
        ADatePicker: DatePicker, 
        ADivider: Divider, 
        ATextarea: Textarea,
        AButton: Button,
        ASpin: Spin, 
        ATreeSelect: TreeSelect,
        AConfigProvider: ConfigProvider, 
        MinusCircleOutlined
    },  
    data() {
        return {
            ruRu,
            isLoading: false,
            questionnaireData: null,
            isPolicyholderIsBeneficiary: false,
            isPolicyholderIsInsured: false,
            errors: [],
            dictis: {
                cargo_types: null,
                insurance_coverages: null,
                package_types: null,
                tnved_codes: null,
                transport_categories: null,
                transport_types: null
            },
            formState: {
                policyholder_bin: {value: null, isLoading: false},
                policyholder_name: {value: null, isLoading: false},
                insured_bin: {value: null, isLoading: false},
                insured_name: {value: null, isLoading: false},
                beneficiary_bin: {value: null, isLoading: false},
                beneficiary_name: {value: null, isLoading: false},
                cargo_name: {value: null},
                cargo_type_id: {value: null, isLoading: false},
                seats: {value: null},
                weight: {value: null},
                weight_unit: {value: 'т'},
                volume: {value: null},
                volume_unit: {value: 'м3'}, 
                package_type_id: {value: null, isLoading: false},
                tnved_code_id: {value: null, isLoading: false},
                has_special_properties: {value: null},
                special_properties_comment: {value: null, isShowField: false},
                cargo_price: {value: null},
                has_transport_expenses: {value: null},
                transport_expenses: {value: null, isShowField: false, max: null},
                invoice_number: {value: null},
                insurance_amount: {value: null},
                insurance_start_date: {value: null},
                insurance_end_date: {value: null},
                transport_category_id: {value: null, isLoading: false},
                transport_types: {
                    values: [
                        {
                            value: null
                        }
                    ], 
                    isLoading: false
                },
                forwarder_type: {value: null},
                has_forwarder: {value: false},
                forwarder_bin: {value: null, isLoading: false, isShowField: false},
                forwarder_name: {value: null, isLoading: false},
                has_autocarrier: {value: false},
                autocarrier_type: {value: null},
                autocarrier_bin: {value: null},
                autocarrier_name: {value: null, isLoading: false},
                departure_point: {value: null},
                destination_point: {value: null},
                has_transshipment_point: {value: null},
                transshipment_point_comment: {value: null, isShowField: false},
                has_overload_point: {value: null},
                overload_point_comment: {value: null, isShowField: false},
                has_temporary_storage_point: {value: null},
                temporary_storage_comment: {value: null, isShowField: false},
                full_transportation_route: {value: null},
                insurance_coverage_id: {value: null},
            }
        }
    }, 
    mounted() { 
       this.getQuestionnaireData(this.$route.params.id.split('-').join(''))
       this.getAllDicties()
    },
    methods: {
        getQuestionnaireData(id){
            if(localStorage.getItem('lang') !== 'ru'){
                localStorage.setItem('lang', 'ru')
            }
            axios.get(`V1/surveys/cargo/${id}`)
                .then(response => {
                    this.questionnaireData = response.data.data.cargo_survey
                    // this.formState.policyholder_bin.value='test'
                    Object.keys(response.data.data.cargo_survey)?.map(key => {
                        if(this.formState[key]){
                            if(key === 'has_special_properties' || key === 'has_transport_expenses' || key === 'has_transshipment_point' || key === 'has_overload_point' ||  key === 'has_temporary_storage_point'){
                                if(key === 'has_special_properties' ){
                                    this.formState.special_properties_comment.isShowField = response.data.data.cargo_survey[key]
                                }else if( key === 'has_transport_expenses'){
                                    this.formState.transport_expenses.isShowField = response.data.data.cargo_survey[key]
                                }else if(key === 'has_transshipment_point'){
                                    this.formState.transshipment_point_comment.isShowField = response.data.data.cargo_survey[key]
                                }else if(key === 'has_overload_point' ){
                                    this.formState.overload_point_comment.isShowField = response.data.data.cargo_survey[key]
                                }else if(key === 'has_temporary_storage_point'){
                                    this.formState.temporary_storage_comment.isShowField = response.data.data.cargo_survey[key]
                                }
                                this.formState[key].value = response.data.data.cargo_survey[key] ? 1 : 0
                            }else if(key === 'transport_types'){
                                if( response.data.data.cargo_survey[key]?.length > 0){
                                    this.formState[key].values = response.data.data.cargo_survey[key]?.map(item => {
                                        return {
                                            value: item
                                        }
                                    })
                                }
                            }else if(key === 'insurance_end_date' || key === 'insurance_start_date'){
                                this.formState[key].value = response.data.data.cargo_survey[key] ? dayjs(response.data.data.cargo_survey[key], 'DD.MM.YYYY') : null
                            }else if(key === 'autocarrier_type' || key === 'forwarder_type'){
                                this.formState[key].value = Number(response.data.data.cargo_survey[key])
                            }else if(key === 'autocarrier_bin'){
                                this.formState.has_autocarrier.value =  response.data.data.cargo_survey[key]?.length > 0
                                this.formState[key].value = response.data.data.cargo_survey[key]
                            }else if(key === 'forwarder_bin'){
                                this.formState.has_forwarder.value = response.data.data.cargo_survey[key]?.length > 0
                                this.formState[key].value = response.data.data.cargo_survey[key]
                            }else{
                                this.formState[key].value = response.data.data.cargo_survey[key]
                            }
                        }
                    })
                })
                .catch(e => {
                    toaster.error('Не удалось получить данные анкеты!', {
                        position: "top-right"
                    })
                })
        },
        getContractorByIINOrIIN(iin, field){
            if(localStorage.getItem('lang') !== 'ru'){
                localStorage.setItem('lang', 'ru')
            }
            this.formState[field].isLoading = true
            axios.get(`V1/search-client?binOrIin=${iin}&juridical=Y`)
                .then(response => {
                    if(response.data.data.title.length > 0){
                        this.formState[field].value = response.data.data.title
                        this.formState[field].isLoading = false
                        toaster.success('Пользователь успешно найден', {
                            position: "top-right"
                        })
                    }else{
                        this.formState[field].isLoading = false
                        toaster.error('Пожалуйста обратитесь к вашему менеджеру', {
                            position: "top-right"
                        });
                    }
                })
                .catch(e => {
                    toaster.error('Пожалуйста обратитесь к вашему менеджеру', {
                        position: "top-right"
                    });
                    this.formState[field].isLoading = false
                })
        },
        onChangeIINorBIN(e, field, field_name){

            this.formState[field].value = e.target.value.split(' ').join('')
            if(e.target.value.length === 14){
                this.getContractorByIINOrIIN(e.target.value.split(' ').join(''), field_name)
            }else{
                this.formState[field_name].value = ''
            }
        },
        getAllDicties(){
            if(localStorage.getItem('lang') !== 'ru'){
                localStorage.setItem('lang', 'ru')
            }
            this.formState.cargo_type_id.isLoading = true
            this.formState.package_type_id.isLoading = true
            this.formState.tnved_code_id.isLoading = true
            this.formState.transport_category_id.isLoading = true
            this.formState.transport_types.isLoading = true
            axios.get(`/V1/surveys/catalogs/cargo-types`)
                .then(response => {
                    this.dictis.cargo_types = response.data.map(item => {
                        return {
                            value: Number(item.id),
                            label: item.name
                        }
                    })
                    this.formState.cargo_type_id.isLoading = false
                })
                .catch(e => {
                    this.formState.cargo_type_id.isLoading = false
                })
            axios.get(`/V1/surveys/catalogs/insurance-coverages`)
                .then(response => {
                    this.dictis.insurance_coverages = response.data.map(item => {
                        return {
                            value: Number(item.id),
                            label: item.name
                        }
                    })
                    for(let item of this.dictis.insurance_coverages){
                        console.log(item);
                    }
                })
                .catch(e => {
                    console.log(e);
                    
                })
            axios.get(`/V1/surveys/catalogs/package-types`)
                .then(response => {
                    this.dictis.package_types = response.data.map(item => {
                        return {
                            value: Number(item.id),
                            label: item.name
                        }
                    })
                    this.formState.package_type_id.isLoading = false
                })
                .catch(e => {
                    this.formState.package_type_id.isLoading = false
                    
                })
            axios.get(`/V1/surveys/catalogs/tnved-codes`)
                .then(response => {
                    this.dictis.tnved_codes = response.data.map(item => {
                        return {
                            value: Number(item.id),
                            label: item.name
                        }
                    })
                    this.formState.tnved_code_id.isLoading = false
                })
                .catch(e => {
                    this.formState.tnved_code_id.isLoading = false
                })
            axios.get(`/V1/surveys/catalogs/transport-categories`)
                .then(response => {
                    this.dictis.transport_categories = response.data.map(item => {
                        return {
                            value: Number(item.id),
                            label: item.name
                        }
                    })
                    this.formState.transport_category_id.isLoading = false
                })
                .catch(e => {
                    this.formState.transport_category_id.isLoading = false
                })
            axios.get(`/V1/surveys/catalogs/transport-types`)
                .then(response => {
                    const parents = response.data.filter(item => item.is_parent);
                    const children = response.data.filter(item => !item.is_parent);
                    const tree = parents.map(parent => {
                        const parentId = parent.id;
                        const childNodes = children
                        .filter(child => child.parent && child.parent.id === parentId)
                        .map(child => ({
                            title: child.name,
                            value: Number(child.id),
                            key:  Number(child.id),
                        }));

                        return {
                            title: parent.name,
                            value: Number(parent.id),
                            key: Number(parent.id),
                            selectable: false,
                            children: childNodes,
                        };
                    });
                    this.dictis.transport_types = tree 
                    this.formState.transport_types.isLoading = false
                })
                .catch(e => {
                    this.formState.transport_types.isLoading = false
                })
        },
        isPolicyholderIsInsuredChecked(e){
          if(localStorage.getItem('lang') !== 'ru'){
            localStorage.setItem('lang', 'ru')
          }
          this.isPolicyholderIsInsured = e.target.checked
          if(e.target.checked){
            this.formState.insured_bin.value = this.formState.policyholder_bin.value
            this.formState.insured_name.value = this.formState.policyholder_name.value
          }
        },
        isPolicyholderIsBeneficiaryChecked(e) {
            if(localStorage.getItem('lang') !== 'ru'){
                localStorage.setItem('lang', 'ru')
            }
            this.isPolicyholderIsBeneficiary = e.target.checked
            if(e.target.checked){
                this.formState.beneficiary_bin.value = this.formState.policyholder_bin.value
                this.formState.beneficiary_name.value = this.formState.policyholder_name.value
            }
            
        },
        onChangeFields(e, field, type, index){
            if(localStorage.getItem('lang') !== 'ru'){
                localStorage.setItem('lang', 'ru')
            }
            switch(type){
                case 'text': {
                    this.formState[field].value = e.target.value;
                    break;
                }
                case 'number': {
                    let val;
                    if(e){
                        if(e.target){
                        val = Number(e.target.value)
                        }else{
                            val = Number(e)
                        }
                    }else{
                        val = 0
                    }
                    this.formState[field].value = val
                    if(field === 'transport_expenses'){
                        if(this.formState.cargo_price.value * 0.2 < val){
                            this.formState.transport_expenses.value = this.formState.cargo_price.value * 0.2 
                             this.formState.insurance_amount.value = this.formState.cargo_price.value * 0.2  + this.formState.cargo_price.value
                        }else{
                            this.formState.insurance_amount.value = val + this.formState.cargo_price.value
                        }
                    }else if(field === 'cargo_price'){
                        this.formState.insurance_amount.value = val + this.formState.transport_expenses.value
                    }
                    break
                }
                case 'select': {
                    if(field === 'transport_category_id' && e !== 4){
                        this.formState.transport_types.values.splice(1)
                    }
                    this.formState[field].value = Number(e)
                    break;
                }
                case 'radio': {
                    this.formState[field].value = e.target.value
                    switch(field) {
                      case 'has_special_properties' : {
                        if(e.target.value === 1){
                            this.formState[field].value = 1
                            this.formState.special_properties_comment.isShowField = true
                        }else{
                            this.formState[field].value = 0
                            this.formState.special_properties_comment.isShowField = false
                        }
                        break
                      }
                      case 'has_transport_expenses' : {
                        if(Number(e.target.value) === 1){
                            this.formState[field].value = 1
                            this.formState.transport_expenses.isShowField = true
                        }else{
                            this.formState[field].value = 0
                            this.formState.transport_expenses.isShowField = false
                        }
                        break
                      }
                      case 'has_transshipment_point' : {
                         if(Number(e.target.value) === 1){
                            this.formState[field].value = 1
                            this.formState.transshipment_point_comment.isShowField = true
                        }else{
                            this.formState[field].value = 0
                            this.formState.transshipment_point_comment.isShowField = false
                        }
                        break
                      }
                      case 'has_overload_point' : {
                         if(Number(e.target.value) === 1){
                            this.formState[field].value = 1  
                            this.formState.overload_point_comment.isShowField = true
                        }else{
                            this.formState[field].value = 0
                            this.formState.overload_point_comment.isShowField = false
                        }
                        break
                      }
                      case 'has_temporary_storage_point' : {
                         if(Number(e.target.value) === 1){
                            this.formState[field].value = 1  
                            this.formState.temporary_storage_comment.isShowField = true
                        }else{
                            this.formState[field].value = 0  
                            this.formState.temporary_storage_comment.isShowField = false
                        }
                        break
                      }
                      default: {
                        this.formState[field].value = e.target.value
                      }
                    }
                    break;
                }
                case 'treeSelect': {
                    this.formState[field].values[index] = e
                    break;
                }
                case 'date': {
                    this.formState[field].value = e
                    
                    if(field === 'insurance_start_date'){
                        if (this.formState.insurance_end_date.value && e && this.formState.insurance_end_date.value.diff(e, 'month', true) > 6) {
                            this.formState.insurance_end_date.value = null
                        }
                    }else if(field === 'insurance_end_date'){
                        if (this.formState.insurance_start_date.value && e && e.diff(this.formState.insurance_start_date.value, 'month', true) > 6) {
                            this.formState.insurance_start_date.value = null
                        }
                    }
                }
            }
        },
        addDomain(){
            this.formState.transport_types.values.push({value: null})
        },
        removeDomain(domain, index){
            this.formState.transport_types.values = this.formState.transport_types.values.filter((item, i) => i !== index)
        },
        disableStartDate(current){
            if (!this.formState.insurance_end_date.value) return false
            return current && current.isAfter(this.formState.insurance_end_date.value) || current && current.isBefore(this.formState.insurance_end_date.value.subtract(6, 'month'))
        },
        disableEndDate(current){
            if (!this.formState.insurance_start_date.value) return false
            return current && current.isBefore(this.formState.insurance_start_date.value) || current && current.isAfter(this.formState.insurance_start_date.value.add(6, 'month'))
        },
        submitForm(){
            if(localStorage.getItem('lang') !== 'ru'){
              localStorage.setItem('lang', 'ru')
            }
            let error = []
            let sendData = {}
            for(let key in this.formState){
                if(key === 'transport_types'){
                    sendData[key] = this.formState[key].values.map(item => item.value)
                }else if(key === 'has_special_properties' || key === 'has_transport_expenses' || key === 'has_transshipment_point' || key === 'has_overload_point' || key === 'has_temporary_storage_point'){
                    sendData[key] = this.formState[key].value === 1
                }else if(key === 'insurance_end_date' || key === 'insurance_start_date'){
                      sendData[key] =  this.formState[key].value ? this.formState[key].value.format('YYYY-MM-DD') : null
                }else if(key === 'autocarrier_bin' || key === 'autocarrier_name' || key === 'autocarrier_type'){
                    sendData[key] = this.formState.has_autocarrier.value ? this.formState[key].value : null
                }else if(key === 'forwarder_bin' || key === 'forwarder_name' || key === 'forwarder_type'){
                    sendData[key] = this.formState.has_forwarder.value ? this.formState[key].value : null
                }else{
                    sendData[key] = this.formState[key].value 
                }
                if(key !== 'invoice_number' && key !== 'volume' && key !== 'volume_unit' && key !== 'weight_unit' && (!this.formState[key].value || this.formState[key].value.length < 0)){
                    if(key === 'has_special_properties' || key === 'has_transport_expenses' || key === 'has_transshipment_point' || key === 'has_overload_point' || key === 'has_temporary_storage_point' ||  key === 'has_autocarrier' || key === 'has_forwarder' ){
                        if(this.formState[key].value === null){
                            error.push(key)
                        }
                    }else if(key === 'autocarrier_type'){
                      if(this.formState.has_autocarrier.value && this.formState.autocarrier_type.value === null){
                        error.push(key)
                      }
                    }else if(key === 'forwarder_type'){
                      if(this.formState.has_forwarder.value && this.formState.forwarder_type.value === null){
                        error.push(key)
                      }
                    }else if(key === 'autocarrier_bin' || key === 'autocarrier_name'){
                        if(this.formState.has_autocarrier.value && (this.formState[key].value === null || this.formState[key].value.length <= 0) && this.formState.autocarrier_type.value === 1){
                            error.push(key)
                        }
                    }else if(key === 'forwarder_bin' || key === 'forwarder_name'){
                        if(this.formState.has_forwarder.value && (this.formState[key].value === null || this.formState[key].value.length <= 0) && this.formState.forwarder_type.value === 1){
                            error.push(key)
                        }
                    }else if(key === 'transport_types'){
                        if(this.formState[key].values.length === 0 || this.formState[key].values[0].value === null){
                            error.push(key)
                        }
                    }else if(key === "special_properties_comment"){
                        if(this.formState.has_special_properties.value ||  this.formState.has_special_properties.value == 1){
                            error.push(key)
                        }
                    }else if(key === "transport_expenses"){
                        if(this.formState.has_transport_expenses.value || this.formState.has_transport_expenses.value == 1){
                            error.push(key)
                        }
                    }else if(key === "transshipment_point_comment"){
                        if(this.formState.has_transshipment_point.value || this.formState.has_transshipment_point.value == 1){
                            error.push(key)
                        }
                    }else if(key === "overload_point_comment"){
                        if(this.formState.has_overload_point.value || this.formState.has_overload_point.value == 1){
                            error.push(key)
                        }
                    }else if(key === "temporary_storage_comment"){
                        if(this.formState.has_temporary_storage_point.value || this.formState.has_temporary_storage_point.value == 1){
                            error.push(key)
                        }
                    }else if(key !== 'transport_types'){
                        error.push(key)
                    }
                }else if(key === 'transport_types' && this.formState.transport_types.values[0].value === null){
                    error.push(key)
                }
            }
            this.errors = error;
            
            if(error.length === 0){
                axios.post(`V1/surveys/cargo/${this.$route.params.id.split('-').join('')}`, sendData).then(response => {
                    if(response.data){
                        toaster.success('Данные сохранены!', {
                            position: "top-right"
                        })
                    }
                }).catch(error => {
                    let message;
                    if (axios.isAxiosError(error) && error.response) {
                        message = error.response.data.message;
                    } else {
                        message = String(error);
                    }
                    toaster.error(message, {
                        position: "top-right"
                    })
                })
            }else{
                this.errors = error
                
                toaster.error('Заполните все поля!', {
                    position: "top-right"
                })
                
            }
            
        },
        resetForm(){
            Object.keys(this.formState).map(key => {
                if(this.formState[key]){
                    if(key === 'has_special_properties' || key === 'has_transport_expenses' || key === 'has_transshipment_point' || key === 'has_overload_point' || key === 'has_special_properties' || key === 'has_temporary_storage_point' || key === 'has_forwarder' || key === 'has_autocarrier'){
                        this.formState[key].value = 0
                    }else if(key === 'transport_types'){
                        this.formState[key].values = [{ value: null}]
                    }else if(key === 'insurance_end_date' || key === 'insurance_start_date'){
                        this.formState[key].value = null
                    }else if(key !== 'weight_unit' && key !== 'volume_unit'){
                      this.formState[key].value = null
                    }
                }
            })
        }
    },
   
}
</script>

<style lang="scss" >
    @mixin fontStyle ($family,$style,$weight, $size, $lheight, $color) {
        font-family: $family;
        font-style: normal;
        font-weight: $weight;
        font-size: $size;
        line-height: $lheight;
        color: $color;
    }
    @mixin mobile {
        @media(min-width: 320px) and (max-width: 425px) {
            @content;
        }
    }
    @mixin tablet {
        @media(min-width: 425px) and (max-width: 767px) {
            @content;
        }
    }
    @mixin tablet-1024 {
        @media(min-width: 767px) and (max-width: 1024px) {
            @content;
        }
    }
    @mixin desktop {
        @media(min-width: 1024px) and (max-width: 1440px) {
            @content;
        }
    }
    @mixin desktop-max {
        @media(min-width: 1620px) and (max-width: 2560px) {
            @content;
        }
    }
    .col_p{
        margin-bottom: 0;
    }
    .questionnaire{
        &_title{
            text-align: center;
            font-size: 36px;
            font-weight: 500;
            margin: 30px 0 70px;
        }
        &_card{
            box-shadow: 0px 0px 30px 0px #C5C5C540;
            padding: 40px 90px;
            border-radius: 16px;
            margin-bottom: 20px;
            .error_text{
                label{
                    color: red;
                }
                .ant-col{
                    color: red;
                }
            }
            label{
                font-size: 16px;
            }
            &_title{
                font-size: 22px;
                font-weight: 500;
                padding: 0 20px;
            }
            .ant-input-status-error{
                border-color: red;
            }
            .ant-select-status-error{
                 border-color: red;
             }
            &_input {
                background-color: #EFEFEF;
                height: 55px;
                border-radius: 8px;
                border-color: transparent;
                width: 100%;
                display: flex;
                align-items: center;
                ::placeholder{
                    color: #818181;
                }
                .ant-input{
                    height: 100%;
                    background: transparent;
                }
                .ant-input-prefix{
                    width: 17px;
                    margin-right: 10px;
                    img{
                        width: 100%;
                    }
                }
                .ant-input-number-input-wrap{
                  width: calc(100% - 23px);
                  height: 100%;
                  display: flex;
                  align-items: center;
                  .ant-input-number-input{
                    height: 100% !important;
                  }
                }
                &_number{
                    .ant-input-number-input-wrap{
                        width: calc(100% - 23px);
                        height: 100%;
                        display: flex;
                        align-items: center;
                        .ant-input-number-input{
                            height: 100% !important;
                        }
                    }
                }
            }
            &_select{
                background-color: #EFEFEF;
                height: 55px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                outline: none;
                .ant-select-selector{
                    background: transparent !important;
                    border-color: none !important;
                    outline: none !important;
                    height: 100% !important;
                    display: flex;
                    align-items: center;
                }
            }
            &_radio{
                display: flex;
                gap: 40px;
                .ant-radio-wrapper{
                    .ant-radio{
                        .ant-radio-inner{
                            border-radius: 20% !important;
                            width: 24px !important;
                            height: 24px !important;
                        }
                    }
                }
                &_checkbox{
                    .ant-radio-wrapper{
                        margin: 10px 0;
                        width: 100%;
                        .ant-radio{
                            .ant-radio-inner{
                                border-radius: 20% !important;
                                width: 24px !important;
                                height: 24px !important;
                            }
                        }
                    }
                }
            }
            &_datepicker{
                width: 100%;
                background-color: #EFEFEF;
                height: 55px;
            }
            &_checkbox{
                width: 100%;
                .ant-checkbox-wrapper{
                    width: 100%;
                }
            }
            &_insuranse_sum{
                align-items: center;
                gap: 15px;
                margin-top: 20px;
                &_title{
                    font-size: 22px;
                    font-weight: 400;
                }
                &_data{
                    font-size: 30px;
                    background: linear-gradient(90deg, #F14273 0%, #4540F6 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    display: inline-block;
                }
            }
        }
        &_button{
            width: 300px;
            height: 50px;
            border-radius: 16px;
            border: none;
            box-shadow: none;
            background-color: #3E40FC;
            color: #fff;
            &_primary{
                width: 300px;
                height: 50px;
                border-radius: 16px;
                border: none;
                box-shadow: none;
            }
            :hover{
                color: #fff !important;
            }
        }
        .ant-select-focused{
            .ant-select-selector{
                border: none !important;
                box-shadow: none;
            }
        }
    }
    .dynamicFormItem{
        .ant-form-item-control-input-content{
            display: flex;
            align-items: center;
            gap: 10px;
            .ant-spin-nested-loading {
                width: 100%;
            }
        }
    }
</style>

